setTimeout(()=> {
  $('body').on('click', '.bottomLine', ()=> { 
    if(window.innerWidth > 767) {
      $('.tab_wrapper .product-block-title a').eq(2)[0].click()
      $([document.documentElement, document.body]).animate({
        scrollTop: $('.tab_wrapper .product-block-title a').offset().top
      }, 1000);
    }
    else {
      if($('.tab_wrapper .product-block-content button').eq(2).hasClass('is-open')) {} else {
        $('.tab_wrapper .product-block-content button').eq(2)[0].click()
      }
      $([document.documentElement, document.body]).animate({
        scrollTop: $('.tab_wrapper .product-block-content button').offset().top
      }, 1000);         
    }
  })
  $('body').on('click', '.write-question-review-button,.write-question-review-button', ()=> {
    if(window.innerWidth > 767) {
    }
    else {
      $('.tab_wrapper .product-block-content button').eq(2)[0].click()
      setTimeout(()=> {
        $('.tab_wrapper .product-block-content button').eq(2)[0].click()
      }, 1000)
    }
  })
}, 2000)
